"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useZitcha = void 0;
const tslib_1 = require("tslib");
const common_components_1 = require("@as-react/common-components");
const common_queries_1 = require("@as-react/common-queries");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const uuid_1 = require("uuid");
const fingerprintjs_1 = tslib_1.__importDefault(require("@fingerprintjs/fingerprintjs"));
const pageViewId = (0, uuid_1.v4)();
const useZitcha = () => {
    const { thirdparty } = (0, common_components_1.useAemConfig)();
    const { postCollect } = (0, common_queries_1.zitchaMutations)(thirdparty.zitcha);
    const { mutateAsync: postCollectMutation } = (0, react_query_1.useMutation)(postCollect);
    const collectConversion = (0, react_1.useCallback)((order) => {
        if (!order) {
            return;
        }
        return postCollectMutation({
            event: 'ad-conversions',
            data: {
                action: 'sale',
                customer_identifiers: [
                    {
                        type: 'uuid',
                        value: order.customerUUID,
                        system: 'global',
                    },
                ],
                basket: {
                    currency: order.currency,
                    value: order.priceTotalBasket,
                    products: order.mappedProducts.map(product => ({
                        product_id: `${product.sku}`,
                        product_name: product.description,
                        price_paid: product.price,
                        quantity: product.quantity,
                    })),
                },
                conversion_id: order.orderNumber,
                page_location: window === null || window === void 0 ? void 0 : window.location.href,
                retailer_order_id: order.orderNumber,
                source: 'web',
            },
        });
    }, []);
    const collectClick = (_a) => tslib_1.__awaiter(void 0, [_a], void 0, function* ({ adFormat, adId, placementId }) {
        const fp = yield fingerprintjs_1.default.load();
        const { visitorId } = yield fp.get();
        return postCollectMutation({
            event: 'ad-click',
            data: {
                ad_format: adFormat,
                ad_id: adId,
                click_id: (0, uuid_1.v4)(),
                customer_identifiers: [
                    {
                        type: 'device_fingerprint',
                        system: 'local',
                        value: visitorId,
                    },
                ],
                placement_id: placementId,
                page_view_id: pageViewId,
                page_location: window === null || window === void 0 ? void 0 : window.location.href,
                source: 'web',
            },
        });
    });
    return {
        collectConversion,
        collectClick,
    };
};
exports.useZitcha = useZitcha;
